const store = {
  namespaced: true,
  state: {
    rules: [],
    operator: {
      gt: '大于',
      lt: '小于',
      gte: '大于等于',
      lte: '小于等于',
      equals: '等于',
      all: '包含所有',
      any: '包含任一',
    },
    type: {
      NUM: ['gt', 'lt', 'gte', 'lte', 'equals'],
      STR: ['equals', 'all', 'any'],
    },
  },
  mutations: {
    SET_RULES(state, rules) {
      state.rules = rules;
    },
    UPDATE_RULE(state, rule) {
      state.rules.splice(rule.index, 1, {
        conditions: rule.conditions,
        action: rule.action,
        action_data: rule.action_data,
        end: rule.end,
        tag: rule.tag,
        vars: rule.vars || [],
      })
    },
    ADD_RULE(state, rule) {
      state.rules.push(rule)
    },
    DEL_RULE(state, index) {
      if (index < 0) return;
      state.rules.splice(index, 1)
    },
    MODIFY_POSITION(state, { originalP = 0, newP = 0 }) {
      const data = state.rules[originalP];
      state.rules.splice(originalP, 1);
      state.rules.splice(newP, 0, data);
    },
  },
  actions: {
    setRule({ state, commit, dispatch }, curRule) {
      if (curRule.index >= 0) {
        commit('UPDATE_RULE', curRule);
      } else {
        commit('ADD_RULE', curRule);
      }
      return dispatch('scene/savePortionScene', { key: 'rules', data: state.rules }, { root: true })
    },
    setRules({ commit }, rules = []) {
      commit('SET_RULES', rules)
    },
    delRule({ commit, dispatch, state }, index) {
      commit('DEL_RULE', index)
      return dispatch('scene/savePortionScene', { key: 'rules', data: state.rules }, { root: true })
    }, 
    // 修改位置
    modifyPosition({ commit, dispatch, state }, positionInfo) {
      commit('MODIFY_POSITION', positionInfo);
      return dispatch('scene/savePortionScene', { key: 'rules', data: state.rules }, { root: true })
    },
  }
}
export default store

